import { useMissionsTranslation } from '../../../../ui/hooks';
import { TextCell } from '@juvare/common-data-table-ui/DataTable';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import HistoryToggleOffOutlinedIcon from '@mui/icons-material/HistoryToggleOffOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import { Box, Tooltip } from '@mui/material';
import React from 'react';
export function AdminParticipantFullNameRenderer({ row, }) {
    const { t } = useMissionsTranslation();
    return (React.createElement(TextCell, { sx: {
            display: 'flex',
            textWrap: 'wrap',
            alignItems: 'center',
            color: themeColors.text.subtle,
            gap: 1,
        } },
        row.columns.participantFullName,
        row.columns.addedByAdmin && (React.createElement(Box, { sx: { display: 'flex', flex: 1, justifyContent: 'center', maxWidth: 20 } },
            React.createElement(Tooltip, { title: t('shifts.volunteerWasAddedByTheAdmin') },
                React.createElement(ManageAccountsOutlinedIcon, { sx: { color: themeColors.icon.subtle }, fontSize: 'small' })))),
        !row.columns.isParticipantAvailable && (React.createElement(Box, { sx: { display: 'flex', flex: 1, justifyContent: 'center', maxWidth: 20 } },
            React.createElement(Tooltip, { title: t('shifts.volunteerIsAssignedToOverlappingShift') },
                React.createElement(HistoryToggleOffOutlinedIcon, { sx: { color: themeColors.accent.red.base }, fontSize: 'small' }))))));
}
